module.exports = require("npm:js-marker-clusterer@1.0.0/src/markerclusterer.js");